import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import EmptyTailoredGenerationIcon from "../../../../assets/images/icons/EmptyTailoredGenerationIcon";
import styles from "./TgProjectsEmpty.module.scss";

const TgProjectsEmpty = () => {
	const { t } = useTranslation("tg", { keyPrefix: "projects.dashboard.emptyState" });
	return (
		<Box className={styles.header}>
			<EmptyTailoredGenerationIcon />
			<Typography className={styles.description}>{t("description")}</Typography>
		</Box>
	);
};

export default observer(TgProjectsEmpty);
